var team = {};
module['exports'] = team;
team.suffix = require("./suffix");
team.name = require("./name");